import CircularProducts from '../assets/img/CircularProducts.jpg';
import ConcreteRecycledAggregates from '../assets/img/ConcreteRecycledAggregates.jpg';
import ConcreteModulesConcrete from '../assets/img/ConcreteModulesConcrete.jpg';

import ProductsUsingLessMaterial from '../assets/img/ProductsUsingLessMaterial.jpg';
import Special3DConcretePrinting from '../assets/img/Special3DConcretePrinting.png';
import UHPCs from '../assets/img/UHPC.jpg';

import DecarbonisedProducts from '../assets/img/DecarbonisedProducts.jpg';
import BrevikCCS from '../assets/img/BrevikCCS.jpg';
import LengfurtCCU from '../assets/img/LengfurtCCU.jpg';

import CarbonReducedProducts from '../assets/img/CarbonReducedProducts.png';
import SubstitutingClinkerWithFlyAsh from '../assets/img/SubstitutingClinkerWithFlyAsh.jpg';
import SubstitutingClinkerWithCalcineClay from '../assets/img/SubstitutingClinkerWithCalcineClay.jpg';

import Wheel from '../assets/img/wheel.png';
import Pfeil from '../assets/img/pfeil.png';



export const images = {
  CircularProducts,
  ConcreteRecycledAggregates,
  ConcreteModulesConcrete,
  ProductsUsingLessMaterial,
  Special3DConcretePrinting,
  UHPCs,
  DecarbonisedProducts,
  BrevikCCS,
  LengfurtCCU,
  CarbonReducedProducts,
  SubstitutingClinkerWithFlyAsh,
  SubstitutingClinkerWithCalcineClay,
  Wheel,
  Pfeil
}










